﻿'use strict';

angular.module('ntmApp').factory('GroupingGridCustomizer', [function () {

    var customizer = {};

    customizer.buildOptions = function (groupingOptions, gridOptions) {

        gridOptions = gridOptions || {};

        if(gridOptions.columnDefs && groupingOptions.columns) {
            
            gridOptions.groupingShowCounts = groupingOptions.groupingShowCounts;
            gridOptions.groupingNullLabel = groupingOptions.groupingNullLabel;

            groupingOptions.columns.forEach(function (groupColumn) {

                var uiGridColumn = gridOptions.columnDefs.firstOrDefault(function (def) {
                    return def.fieldName === groupColumn.column;
                });

                if (uiGridColumn) {

                    if (groupColumn.aggregation) {
                        uiGridColumn.treeAggregationType = groupColumn.aggregation;
                        uiGridColumn.customTreeAggregationFinalizerFn = function (aggregation) {
                            aggregation.rendered = parseFloat(aggregation.value).toFixed(uiGridColumn.decimals);
                        };
                    } else {

                        uiGridColumn.grouping = {
                            groupPriority: groupColumn.groupPriority && groupColumn.groupPriority >= 0 ? groupColumn.groupPriority : 0
                        };

                        uiGridColumn.sort = {
                            priority: groupColumn.groupPriority && groupColumn.groupPriority >= 0 ? groupColumn.groupPriority : 0,
                            direction: 'asc',
                            hide: true
                        };
                    }
                }
            });
        }

        return gridOptions;

    };

    return customizer;

}]);